import PropTypes from 'prop-types';
import * as React from 'react';

import styles from './GridFilterLabel.less';

class GridFilterLabel extends React.PureComponent {
  render() {
    const {label} = this.props;
    return (
      <span className={styles.dlGridFilterLabel} title={label}>
        {label}
      </span>
    );
  }
}

GridFilterLabel.displayName = 'GridFilterLabel';

GridFilterLabel.propTypes = {
  label: PropTypes.string,
};

GridFilterLabel.defaultProps = {
  label: '',
};

export default GridFilterLabel;
